/**
 * Página Producer - Busca de Cidades
 */
(function() {
    'use strict';

    function initCitySearch() {
        const searchInput = document.getElementById('city-search-input');
        const resultsContainer = document.getElementById('city-search-results');
        const dataScript = document.getElementById('city-search-data');
        
        if (!searchInput || !resultsContainer) return;

        const MAX_VISIBLE_RESULTS = 10;

        function limitVisibleHeight(container, maxVisible) {
            const items = container.children;
            if (items.length <= maxVisible) {
                container.style.maxHeight = '';
                return;
            }

            const itemGap = 16; // space-y-4
            let visibleHeight = 0;
            for (let i = 0; i < maxVisible; i++) {
                visibleHeight += items[i].offsetHeight;
                if (i < maxVisible - 1) visibleHeight += itemGap;
            }
            container.style.maxHeight = visibleHeight + 'px';
        }

        let allUnits = [];
        if (dataScript) {
            try {
                const data = JSON.parse(dataScript.textContent);
                allUnits = data.unitCaptacao || [];
            } catch (e) {
                console.error('Erro ao carregar dados das unidades', e);
            }
        }

        function searchCity(query) {
            if (!query || query.trim().length < 2) {
                resultsContainer.classList.add('hidden');
                resultsContainer.innerHTML = '';
                return;
            }

            const searchTerm = query.trim().toLowerCase();
            const filtered = allUnits.filter(unit => {
                // Busca apenas pelo nome da unidade (name)
                if (!unit.name) return false;
                
                return unit.name.toLowerCase().includes(searchTerm);
            });

            if (filtered.length > 0) {
                resultsContainer.classList.remove('hidden');
                resultsContainer.innerHTML = filtered.map(unit => {
                    const textContent = (unit.text || '').trim();
                    const textOnly = textContent.replace(/<[^>]*>/g, '').trim();
                    const hasText = textOnly.length > 0;
                    return `
                        <div class="border border-[#5E8659]/30 rounded-lg bg-white ${hasText ? 'p-4' : 'px-4 py-3'}">
                            <div class="text-lg font-bold text-[#182F43] dark:text-primary-dark ${hasText ? 'mb-2' : ''}">
                                ${unit.name || ''}
                            </div>
                            ${hasText ? `<div class="text-base font-light text-dark dark:text-dark-dark">${textContent}</div>` : ''}
                        </div>
                    `;
                }).join('');
                limitVisibleHeight(resultsContainer, MAX_VISIBLE_RESULTS);
            } else {
                resultsContainer.style.maxHeight = '';
                resultsContainer.classList.remove('hidden');
                resultsContainer.innerHTML = `
                    <div class="p-4 text-left text-[16px] text-[400] text-[#767676] italic">
                        O <b>nome não foi encontrado</b> ou <b>não consta na lista de cidades</b> com captação. Verifique se está correto e tente novamente ou busque por outra cidade.
                    </div>
                `;
            }
        }

        // Debounce para evitar muitas buscas
        let timeout;
        searchInput.addEventListener('input', function(e) {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                searchCity(e.target.value);
            }, 300);
        });
    }

    // Inicializar quando o DOM estiver pronto
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCitySearch);
    } else {
        initCitySearch();
    }
})();

/**
 * Select de categorias ProCampo
 */
function goProcampoCategory(category) {
    if (!category) {
        return;
    }

    window.location = '/procampo/conteudo/categoria/' + category;
}

(function() {
    'use strict';
    
    function initProcampoCategorySelect() {
        $('.slider-procampo-content select[name="category"]').on('change', function (evt) {
            const category = $(this).val();
            if (category) {
                goProcampoCategory(category);
            }
        });
    }
    
    // Inicializar quando o DOM estiver pronto
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initProcampoCategorySelect);
    } else {
        initProcampoCategorySelect();
    }
})();

